module.exports = __webpack_public_path__ + "static/media/task8Planet1.6e36f1e0.png";